export const pdfErrors = {
  surveyLineList:
    "Sorry, there was an error downloading your survey line list pdf",
  revision: "Sorry, there was an error downloading your revision pdf"
};
